import Classes from "./Classes";
import Sclass from "./classes/Class";
import Students from "./Students";
import Maincomponent from "./Main";
import Student from "./students/Student";
import Trainers from './../student/Trainers'
import Trainer from './../trainer/trainer'
import UnattachedStudents from './UnattachedStudents'
import HwArchive from './homeworks/HwArchive'
import OutsiderAnketa from './outsider/outsider_anketa'

// конкурсы
import Matrius from '../contests/matrius/Matrius'
import TeamPage from '../contests/matrius/TeamPage'
import DrawContest from '../contests/draw_contest/DrawContest'

export default [
  { path: '/', component: Maincomponent },
  { path: '/classes', component: Classes },
  { path: '/class/:id', component: Sclass },
  { path: '/students', component: Students },
  { path: '/student/:id', component: Student },
  { path: '/hw-archive', component: HwArchive },
  { path: '/ot-anketa', component: OutsiderAnketa },
  { path: '/trainers', component: Trainers },
  { path: '/unattached', component: UnattachedStudents },
  { path: '/trainer/:component', component: Trainer },

  // { path: '/draw-contest', component: DrawContest },

  { path: '/matrius', component: Matrius },
  { path: '/matrius/team/:id', component: TeamPage },
];